// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer-container {
  background: var(--bg-footer);
  color: var(--primary-text-color);
  padding: 80px 8% 30px;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  width: 100vw;
  margin-left: calc(-50vw + 50%);
  position: relative;
  overflow: hidden;
  border-top: 1px solid var(--border-footer);
}

.footer-glow {
  position: absolute;
  top: -200px;
  left: 50%;
  transform: translateX(-50%);
  width: 800px;
  height: 400px;
  background: radial-gradient(ellipse at center, rgba(0, 224, 182, 0.06) 0%, transparent 70%);
  pointer-events: none;
}

.footer-content {
  position: relative;
  z-index: 1;
  max-width: 1400px;
  margin: 0 auto;
}

.footer-top {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 60px;
  margin-bottom: 50px;
}

.footer-left {
  max-width: 420px;
  width: 100%;
}

.footer-logo {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
}

.footer-brand-name {
  margin: 0;
  font-size: 22px;
  font-weight: 600;
  letter-spacing: 0.3px;
}

.footer-subscribe-text {
  font-size: 14px;
  margin: 0 0 18px 0;
  color: var(--color-footer-text);
  font-weight: 400;
}

.footer-contact-info {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.footer-contact-item {
  display: flex;
  align-items: center;
  gap: 12px;
  color: var(--color-footer-text);
  font-size: 14px;
  line-height: 1.5;
}

.footer-contact-item svg {
  flex-shrink: 0;
  opacity: 0.7;
  color: #00e0b6;
}

.footer-contact-item span {
  word-break: break-word;
}

.footer-right {
  display: flex;
  gap: 80px;
  flex-wrap: wrap;
}

.footer-link-group {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.footer-link-group h3 {
  font-size: 14px;
  font-weight: 600;
  margin: 0 0 8px 0;
  color: var(--color-footer-heading);
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

.footer-link-group a {
  color: var(--color-footer-text);
  text-decoration: none;
  font-size: 14px;
  font-weight: 400;
  transition: color 0.2s ease, transform 0.2s ease;
  display: inline-block;
  width: fit-content;
}

.footer-link-group a:hover {
  color: #00e0b6;
  transform: translateX(4px);
}

.footer-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 24px;
  border-top: 1px solid var(--border-footer);
}

.footer-bottom p {
  margin: 0;
  color: var(--color-footer-text);
  font-size: 13px;
}

.footer-bottom-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.theme-toggle {
  background: var(--bg-footer-input);
  border: 1px solid var(--border-footer-input);
  color: var(--color-footer-text);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  transition: all 0.3s cubic-bezier(0.22, 1, 0.36, 1);
}

.theme-toggle:hover {
  color: #00e0b6;
  border-color: rgba(0, 224, 182, 0.3);
  background: rgba(0, 224, 182, 0.08);
  transform: translateY(-2px);
}

.back-to-top {
  background: var(--bg-footer-input);
  border: 1px solid var(--border-footer-input);
  color: var(--color-footer-text);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  transition: all 0.3s cubic-bezier(0.22, 1, 0.36, 1);
}

.back-to-top:hover {
  color: #00e0b6;
  border-color: rgba(0, 224, 182, 0.3);
  background: rgba(0, 224, 182, 0.08);
  transform: translateY(-2px);
}

@media (max-width: 768px) {
  .footer-container {
    padding: 60px 5% 24px;
    max-width: none;
  }

  .footer-top {
    flex-direction: column;
    gap: 40px;
  }

  .footer-right {
    gap: 40px;
    justify-content: flex-start;
  }
}

@media (max-width: 480px) {
  .footer-container {
    padding: 40px 16px 20px;
    max-width: none;
  }

  .footer-top {
    gap: 32px;
  }

  .footer-right {
    flex-direction: column;
    gap: 24px;
    width: 100%;
  }

  .footer-bottom {
    flex-direction: column;
    gap: 16px;
    text-align: center;
  }

  .footer-bottom-actions {
    justify-content: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Footer/Footer.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,gCAAgC;EAChC,qBAAqB;EACrB,yGAAyG;EACzG,YAAY;EACZ,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,aAAa;EACb,2FAA2F;EAC3F,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kCAAkC;EAClC,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,gDAAgD;EAChD,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,0CAA0C;AAC5C;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kCAAkC;EAClC,4CAA4C;EAC5C,+BAA+B;EAC/B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mDAAmD;AACrD;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,4CAA4C;EAC5C,+BAA+B;EAC/B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mDAAmD;AACrD;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE;IACE,qBAAqB;IACrB,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,SAAS;IACT,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;AACF","sourcesContent":[".footer-container {\n  background: var(--bg-footer);\n  color: var(--primary-text-color);\n  padding: 80px 8% 30px;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\n  width: 100vw;\n  margin-left: calc(-50vw + 50%);\n  position: relative;\n  overflow: hidden;\n  border-top: 1px solid var(--border-footer);\n}\n\n.footer-glow {\n  position: absolute;\n  top: -200px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 800px;\n  height: 400px;\n  background: radial-gradient(ellipse at center, rgba(0, 224, 182, 0.06) 0%, transparent 70%);\n  pointer-events: none;\n}\n\n.footer-content {\n  position: relative;\n  z-index: 1;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.footer-top {\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 60px;\n  margin-bottom: 50px;\n}\n\n.footer-left {\n  max-width: 420px;\n  width: 100%;\n}\n\n.footer-logo {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 24px;\n}\n\n.footer-brand-name {\n  margin: 0;\n  font-size: 22px;\n  font-weight: 600;\n  letter-spacing: 0.3px;\n}\n\n.footer-subscribe-text {\n  font-size: 14px;\n  margin: 0 0 18px 0;\n  color: var(--color-footer-text);\n  font-weight: 400;\n}\n\n.footer-contact-info {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.footer-contact-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  color: var(--color-footer-text);\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.footer-contact-item svg {\n  flex-shrink: 0;\n  opacity: 0.7;\n  color: #00e0b6;\n}\n\n.footer-contact-item span {\n  word-break: break-word;\n}\n\n.footer-right {\n  display: flex;\n  gap: 80px;\n  flex-wrap: wrap;\n}\n\n.footer-link-group {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.footer-link-group h3 {\n  font-size: 14px;\n  font-weight: 600;\n  margin: 0 0 8px 0;\n  color: var(--color-footer-heading);\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n}\n\n.footer-link-group a {\n  color: var(--color-footer-text);\n  text-decoration: none;\n  font-size: 14px;\n  font-weight: 400;\n  transition: color 0.2s ease, transform 0.2s ease;\n  display: inline-block;\n  width: fit-content;\n}\n\n.footer-link-group a:hover {\n  color: #00e0b6;\n  transform: translateX(4px);\n}\n\n.footer-bottom {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-top: 24px;\n  border-top: 1px solid var(--border-footer);\n}\n\n.footer-bottom p {\n  margin: 0;\n  color: var(--color-footer-text);\n  font-size: 13px;\n}\n\n.footer-bottom-actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.theme-toggle {\n  background: var(--bg-footer-input);\n  border: 1px solid var(--border-footer-input);\n  color: var(--color-footer-text);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  transition: all 0.3s cubic-bezier(0.22, 1, 0.36, 1);\n}\n\n.theme-toggle:hover {\n  color: #00e0b6;\n  border-color: rgba(0, 224, 182, 0.3);\n  background: rgba(0, 224, 182, 0.08);\n  transform: translateY(-2px);\n}\n\n.back-to-top {\n  background: var(--bg-footer-input);\n  border: 1px solid var(--border-footer-input);\n  color: var(--color-footer-text);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  transition: all 0.3s cubic-bezier(0.22, 1, 0.36, 1);\n}\n\n.back-to-top:hover {\n  color: #00e0b6;\n  border-color: rgba(0, 224, 182, 0.3);\n  background: rgba(0, 224, 182, 0.08);\n  transform: translateY(-2px);\n}\n\n@media (max-width: 768px) {\n  .footer-container {\n    padding: 60px 5% 24px;\n    max-width: none;\n  }\n\n  .footer-top {\n    flex-direction: column;\n    gap: 40px;\n  }\n\n  .footer-right {\n    gap: 40px;\n    justify-content: flex-start;\n  }\n}\n\n@media (max-width: 480px) {\n  .footer-container {\n    padding: 40px 16px 20px;\n    max-width: none;\n  }\n\n  .footer-top {\n    gap: 32px;\n  }\n\n  .footer-right {\n    flex-direction: column;\n    gap: 24px;\n    width: 100%;\n  }\n\n  .footer-bottom {\n    flex-direction: column;\n    gap: 16px;\n    text-align: center;\n  }\n\n  .footer-bottom-actions {\n    justify-content: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
